import React from "react";
import "./AcceptVendorModal.css";

const AcceptVendorModal = ({ brandName, isNewAccount, loading, error, onConfirm, onCancel }) => {
  return (
    <div className="avm-overlay" onClick={onCancel}>
      <div className="avm-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="avm-title">Accept {brandName}?</h3>
        <p className="avm-sub">This sends them an acceptance email right away.</p>

        <div className="avm-preview">
          <p className="avm-preview-label">They'll receive:</p>
          {isNewAccount ? (
            <ul>
              <li>An acceptance email with a link to set up their account and choose a password</li>
              <li>Plain-language, step-by-step instructions for logging in</li>
            </ul>
          ) : (
            <ul>
              <li>An acceptance email confirming their spot for this event</li>
              <li>A link to log in with their existing account</li>
            </ul>
          )}
        </div>

        {error && <p className="avm-error">{error}</p>}

        <div className="avm-actions">
          <button className="avm-btn avm-btn--ghost" onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button className="avm-btn avm-btn--confirm" onClick={onConfirm} disabled={loading}>
            {loading ? "Accepting…" : "Confirm & send email"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcceptVendorModal;